// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"055781bb","253":"6824cc46","637":"0123dc33","694":"c21d7447","760":"9980b999","820":"4296a828","908":"cfce24ae","932":"055781bb","940":"93f70340"}[chunkId] + ".chunk.css";
};